import axios from 'axios';
import { useConfig } from '../config';
import { useState } from 'react';
import { Res } from '../state/api';
import { AddressSuggestion, ApiAddressSuggestions, ApiCompanySearch } from '../types';

export function useFormSuggestions() {
	const { api } = useConfig();
	const [companySearchResults, setCompanySearchResults] = useState<ApiCompanySearch>();
	const [addressSuggestions, setAddressSuggesstions] = useState<AddressSuggestion[]>([]);

	async function checkCompany(companyName: string): Promise<ApiCompanySearch> {
		try {
			const data: ApiCompanySearch = (await axios.get(api + Res.companySearch.uri({ companyName }))).data;
			return data;
		} catch (e) {
			// a lookup that helps the customer fill the form in; every caller takes the result and
			// none of them the rejection, and no suggestions is a fair answer when we cannot ask
			return [] as unknown as ApiCompanySearch;
		}
	}

	async function getAddressSuggestions(street: string) {
		if (street.length === 0) return;

		try {
			const res = (await axios.get<ApiAddressSuggestions>(api + Res.addressSuggestionsCheck.uri({ street })))
				.data;
			const { suggestions } = res;

			if (suggestions && suggestions.length > 0) {
				const filteredSuggestions = suggestions.reduce((suggestionsAcc: AddressSuggestion[], obj) => {
					const localityExist = suggestionsAcc.find(({ postcode }) => obj.postcode === postcode);
					if (!localityExist) suggestionsAcc.push(obj);
					return suggestionsAcc;
				}, []);
				setAddressSuggesstions(filteredSuggestions);
			}
		} catch (e: unknown) {
			throw e;
		}
	}

	function filterUniqueZip(suggestions: AddressSuggestion[], zip: string | undefined) {
		if (zip === undefined) return suggestions;
		return suggestions.filter(({ postcode }) => postcode.startsWith(zip));
	}

	return {
		checkCompany,
		companySearchResults,
		setCompanySearchResults,
		addressSuggestions,
		setAddressSuggesstions,
		getAddressSuggestions,
		filterUniqueZip,
	};
}
